import * as React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

/** AI-Generated Documentation - Please Read with Caution */

/** A component for displaying Material Icons with customizable styling. */
class Icon extends React.Component {
  static propTypes = {
    /** The name of the Material icon to display */
    name: PropTypes.string.isRequired,
    /** When true, adds lineHeight: 'inherit' */
    overrideInherit: PropTypes.bool,
    /** Custom style class (appended to 'text-' class) */
    style: PropTypes.string,
    /** Size of the icon in pixels */
    size: PropTypes.number,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'size' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { size, overrideInherit, name } = this.props;
    const style = overrideInherit ? {} : { lineHeight: 'inherit' };
    if (size) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fontSize' does not exist on type '{ line... Remove this comment to see the full error message
      style.fontSize = size + 'px';
    }
    const styleClass = style ? 'text-' + style : undefined;
    return (
      <i className={classnames('material-icons', styleClass)} style={style}>
        {name}
      </i>
    );
  }
}

export default Icon;
